import * as React from 'react'
import { GroupModel } from '@/modules/drivers/types/groups'
import EditGroupListItem from '../../../modals/groups/edit/EditGroupListItem'
import { faUsersSolid } from '@/lib/fa'
import GroupsLIstNavbar from '../components/GroupsLIstNavbar'

const EditGroupsCustomList = ({
  groups,
  setSelectedGroup,
}: {
  groups: GroupModel[]
  setSelectedGroup: (group) => void
}) => {
  return (
    <div>
      <GroupsLIstNavbar title="Autorskie" />
      <div className="tw-flex tw-flex-col">
        {groups.map((group) => (
          <EditGroupListItem
            key={group.id}
            group={group}
            icon={faUsersSolid}
            setSelectedGroup={setSelectedGroup}
          />
        ))}
      </div>
    </div>
  )
}

export default EditGroupsCustomList
